// extracted by mini-css-extract-plugin
export default {"container":"pro_pGHU0","inner":"pro_inn_26CRh","label":"pro_lab_8B-PX","imageContainer":"pro_ima_2O8mc","imageFrame":"pro_ima_2b7eJ","image":"pro_ima_2mpeu"};